import { $_app_server } from '@/_helpers'

export const actService = {
  sendAct,
  loadActs,
  loadMerchWithActs,
  downloadSignedAct,
  removeAct,
  changeEditable,
  downloadZipActs,
  excel,
  downloadActFile
}

let f_resp = (response) => response.data;

function sendAct(obj) {
  return $_app_server.post("act/sendAct", obj).then(f_resp)
}

function loadActs(month, year, user_id) {
  return $_app_server.get(`act/loadActs?month=${month}&year=${year}&user_id=${user_id}`).then(f_resp)
}

function loadMerchWithActs(month, year, organizationId) {
  return $_app_server.get(`act/loadMerchWithAct?month=${month}&year=${year}&organizationId=${organizationId}`).then(f_resp)
}

function downloadSignedAct(actId) {
  return $_app_server.get(`act/downloadSignedAct?actId=${actId}`, {
    responseType: 'blob'
  })
}

function removeAct(actId) {
  return $_app_server.delete(`act/delete/${actId}`).then(f_resp)
}

function changeEditable(actId) {
  return $_app_server.post(`act/changeEditable?actId=${actId}`).then(f_resp)
}

function downloadZipActs(month, year) {
  return $_app_server.get(`act/export/zip?month=${month}&year=${year}`, {
    responseType: 'blob'
  })
}

function excel(month, year) {
  return $_app_server.get(`act/export/excel?month=${month}&year=${year}`, {
    responseType: 'blob',
  })
}

function downloadActFile(fileUuid) {
  return $_app_server.get(`act/checkActFile?fileUuid=${fileUuid}`, {
    responseType: 'blob'
  })
}